import React, { type FC, type PropsWithChildren } from 'react';
import { Box, token } from '@bynder/design-system';
import { IconInfo } from '@bynder/icons';
import generateTestId from '~/helpers/testIdHelpers';
import { AlertBodyWrapper, AlertContent, AlertIconWrapper } from './Alert.styled';

type AlertProps = PropsWithChildren;

export const Alert: FC<AlertProps> = ({ children }) => {
    return (
        <Box paddingTop="4" paddingBottom="4" {...generateTestId('designs-bulk-export-modal-alert')}>
            <AlertContent gap="3">
                <AlertIconWrapper>
                    <IconInfo style={{ color: token.red500 }} />
                </AlertIconWrapper>
                <AlertBodyWrapper>{children}</AlertBodyWrapper>
            </AlertContent>
        </Box>
    );
};
